export const locale = {
    lang: 'vn',
    data: {
        'DEFAULT_DIALOG': {
            'ACCEPT_BTN_TEXT': 'Đồng ý',
            'CANCEL_BTN_TEXT': 'Hủy'
        }
    }
};
